import {
  Directive,
  ElementRef,
  HostListener,
  Output,
  EventEmitter,
  AfterViewInit,
  Input,
} from '@angular/core';
import * as _ from 'lodash';
import { fromEvent, interval, throttle } from 'rxjs';

@Directive({
    selector: '[prAccordion]',
    standalone: false
})
export class EaAccordionDirective implements AfterViewInit {
  @Output() toggle: EventEmitter<any> = new EventEmitter();
  @Input() prAccordion: boolean;
  @Input() maxFoldedElements: number;
  @Input() minHeight: any = 'auto';
  @Input() maxWidth: number;
  @Input() minWidth: number;
  @Input() offsetX: number = 0;
  @Input() offsetY: number = 0;
  accordion;
  accordionMinHeight;
  resizeEvent;

  constructor(private _elementRef: ElementRef) {
    const resizeEvent = fromEvent(window, 'resize');
    const resize = resizeEvent.pipe(throttle(ev => interval(100)));
    resize.subscribe(x => {
      let ignoreWidth = false;
      if (!this.isInScreenRange()) {
        this.accordion.classList.remove('ea-accordion');
        this.accordion.style.maxHeight = 'inherit';
        this.resetAccordionChildTransform(0, 0);
        // this.toggleFoldAccordion(false);
      } else if (this.isInScreenRange()) {
        this.initAccordion(!this.accordion.classList.contains('open'));
        if (!this.accordion.classList.contains('open'))
          this.toggleFoldAccordion(true);
      }
    });
  }

  ngAfterViewInit() {
    this.accordion = this._elementRef.nativeElement.closest('[accordion]')[0];
    if (!this.accordion)
      this.accordion = this._elementRef.nativeElement.find('[accordion]')[0];
    if (!this.isInScreenRange()) return;
    this.initAccordion();
  }

  initAccordion(closed: boolean = true) {
    this.calculateHeight();
    this.toggleFoldAccordion(closed);
    this.accordion.classList.add('ea-accordion');
    this.accordion.style.maxHeight = `${this.accordionMinHeight}px`;
  }

  @HostListener('click', ['$event.target'])
  public onClick(targetElement) {
    if (this.isInScreenRange() && targetElement.closest('[accordion-toggle]')) {
      this.accordion.classList.toggle('open');
      this.calculateHeight();
      if (this.accordion.classList.contains('open')) {
        //open
        this.accordion.style.maxHeight = `${this.accordionMinHeight}px`;
        this.toggleFoldAccordion(false);
        this.toggle.emit(true);
      } else {
        //close
        this.accordion.style.maxHeight = `${this.accordionMinHeight}px`;
        this.toggleFoldAccordion(true);
        this.toggle.emit(false);
      }
    }
  }
  outerHeight(elem: HTMLElement, includeMargin: boolean): number {
    let height = elem.offsetHeight;
    if (includeMargin) {
      let computedStyle = window.getComputedStyle(elem);
      let marginTop = parseFloat(computedStyle.marginTop);
      let marginBottom = parseFloat(computedStyle.marginBottom);
      height += marginTop + marginBottom;
    }
    return height;
  }

  calculateHeight() {
    if (this.accordion.classList.contains('open')) {
      this.accordionMinHeight =
        _(this.accordion.children)
          .map(child => this.outerHeight(child, true))
          .sum() * 10;
    } else if (this.minHeight == 'auto') {
      this.accordionMinHeight = this.outerHeight(
        this.accordion.children[0],
        true,
      );
    } else if (this.minHeight) {
      let maxHeight = this.minHeight;
      this.accordion.style.maxHeight = maxHeight;
      this.accordionMinHeight = maxHeight;
    } else {
      this.accordionMinHeight = 0;
    }
  }

  toggleFoldAccordion(close: boolean) {
    _.forEach(this.accordion.children, (accordionChild, i: number) => {
      let transformValues = {
        y:
          (close
            ? -(
                this.outerHeight(this.accordion.children[0], true) +
                this.offsetY
              )
            : 0) * i,
        x: (close ? 0 + this.offsetX : 0) * i,
      };
      this.setTransform(accordionChild, transformValues);
      accordionChild.style.zIndex = this.accordion.children.length - i;
      accordionChild.style.opacity = 1;
      if (close) {
        accordionChild.style.height = `${this.outerHeight(
          this.accordion.children[0],
          true,
        )}px`;
        if (this.maxFoldedElements && i > this.maxFoldedElements)
          accordionChild.style.opacity = 0;
        if (i > 0) {
          accordionChild.style['pointer-events'] = 'none';
          accordionChild.style.overflow = 'hidden';
        }
      } else accordionChild.style.height = `-webkit-fill-available`;
    });
  }

  setTransform(item, transformValues: { x: number; y: number }) {
    let transform = `translateY(${transformValues.y}px) translateX(${transformValues.x}px)`;
    item.style['transform'] = transform;
    item.style.webkitTransform = transform;
    item.style.MozTransform = transform;
    item.style.msTransform = transform;
    item.style.OTransform = transform;
  }

  resetAccordionChildTransform(Y, X) {
    _.forEach(this.accordion.children, (accordionChild, i) => {
      accordionChild.style.height = 'unset';
      accordionChild.style.zIndex = 'unset';
      this.setTransform(accordionChild, { y: 0, x: 0 });
      accordionChild.style.opacity = 1;
    });
  }

  isInScreenRange(): boolean {
    let ignoreWidth = false;
    if (!this.maxWidth && !this.minWidth) ignoreWidth = true;
    if (
      (this.maxWidth &&
        !window.matchMedia(`(max-device-width: ${this.maxWidth}px)`).matches) ||
      (this.minWidth &&
        !window.matchMedia(`(min-device-width: ${this.minWidth || 0}px)`)
          .matches)
    )
      return false;
    else if (
      ignoreWidth ||
      (this.maxWidth &&
        window.matchMedia(`(max-device-width: ${this.maxWidth}px)`).matches) ||
      (this.minWidth &&
        window.matchMedia(`(min-device-width: ${this.minWidth || 0})`).matches)
    )
      return true;
  }
}
